import React, { useState, useEffect, useRef, useCallback } from 'react';
import DataGrid, { Column, Paging, FilterRow, HeaderFilter, Selection, FilterPanel } from 'devextreme-react/data-grid';
import moment from 'moment-timezone';
import hash from 'hash.js';
import AssetsService from "../../api/assets.service";
import TenantService from "../../api/tenant.service";
import FloorplanPopupMultiple from '../components/floorplanMultiple2';
import FloorplanGeo2 from '../components/floorplanGeo';
import Toast from 'components/Toast';

export default function App({ assetIds, startDate, endDate, selectedSpace, floorplanGeo, isPoll }) {
  const [data, setData] = useState([]);
  const [tags, setTags] = useState([]);
  const [showMyFloorplan, setShowMyFloorplan] = useState(false);
  const [showMyFloorplan2, setShowMyFloorplan2] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingText, setLoadingText] = useState('Loading...');
  const [hoveredCoordinates, setHoveredCoordinates] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [lines, setLines] = useState(true);
  // const lastFetchParams = useRef("");
  const syncLock = useRef("");

  const assetColorMap = useRef(new Map());
  const dataRef = useRef([]);
  const [colorPalette, setColorPalette] = useState([]);
  const colorPointer = useRef(0);


  // Sync ref so the fetcher always knows what's currently in the table
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });

  const generateDeterministicId = (record) => {
    return hash.sha256().update(`${record.asset}-${record.time}-${record.motion}`).digest('hex');
  };

  // const getAssetColor = (assetName) => {
  //   if (assetColorMap.current.has(assetName)) return assetColorMap.current.get(assetName);
  //   const colorStr = `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255})`;
  //   assetColorMap.current.set(assetName, colorStr);
  //   return colorStr;
  // };
  // Load the colors once on mount
  // useEffect(() => {
  //   fetch("/colors.json")
  //     .then(res => res.json())
  //     .then(data => {
  //       // Convert [7, 0, 3] style arrays to "rgb(R, G, B)" strings
  //       // Note: If your array values are 0-7, multiply by 36 to get 0-255 range
  //       // If they are already 0-255, remove the '* 36' logic.
  //       const formatted = data.map(rgb =>
  //         `rgb(${rgb[0] * 36}, ${rgb[1] * 36}, ${rgb[2] * 36})`
  //       );
  //       setColorPalette(formatted);
  //     });
  // }, []);

  // const getAssetColor = (assetName) => {
  //   // 1. Return existing color if asset is already mapped
  //   if (assetColorMap.current.has(assetName)) {
  //     return assetColorMap.current.get(assetName);
  //   }

  //   // 2. Fallback if palette hasn't loaded yet
  //   if (colorPalette.length === 0) return 'rgb(128, 128, 128)';

  //   // 3. Pick the next color in the sequence
  //   const colorStr = colorPalette[colorPointer.current % colorPalette.length];

  //   // 4. Save mapping and increment pointer for the next NEW asset
  //   assetColorMap.current.set(assetName, colorStr);
  //   colorPointer.current += 1;

  //   return colorStr;
  // };

  const processNewData = useCallback((history) => {
    if (!history || history.length === 0) {
      return { cleaned: [], markers: [] };
    }

    let markers = [];
    const cleaned = history.map(item => {
      const id = generateDeterministicId(item);
      if (item.space?.localCoordinates) {
        markers.push({
          parentId: id,
          id: item.space.id,
          asset: item.asset,
          serialNumber: moment(item.time).format("YYYY-MM-DD HH:mm:ss"),
          spaceCoordinates: {
            x: item.space.localCoordinates.x,
            y: item.space.localCoordinates.y
          },
          // Now uses the palette index instead of random

        });
      }
      return { ...item, id, locationType: item.local_coordinates ? "Local" : "Geo" };
    });
    return { cleaned, markers };
  }, []); // Re-run when palette loads

  const fetchData = useCallback(async () => {
    console.log("her0")
    // --- THE GATEKEEPER ---
    // Generate a unique string based on the current props
    const fingerprint = `${selectedSpace}-${startDate}-${endDate}-${isPoll}-${assetIds.join(',')}`;

    // If the fingerprint matches the last time we successfully ran this, BAIL OUT.
    // This stops the 2nd "Now" render from ever executing the code below.
    if (syncLock.current === fingerprint){
      setLoadingText('No Data');
      return;
    } 
    syncLock.current = fingerprint;
    if (!selectedSpace){
      setLoadingText('No Data');
      return;
    } 

    let from;
    // If parent says isPoll is active, we only fetch what's missing since the last record
    if (isPoll && dataRef.current.length > 0) {
      const latestEntry = dataRef.current[0].time;
      from = moment(latestEntry).format();
    } else {
      if (!startDate) return;
      from = moment(startDate).format();
      setLoadingText('Loading...');
    }

    const to = moment(endDate).format();
    console.log("her1")

    try {
      let history = [];
      const isGeoMap = selectedSpace === "6a21bf9e-fc6b-4bec-9f5c-8f8297772091";
      console.log("her2")

      if (isGeoMap) {
        console.log("her3")
        const res = await AssetsService.locationHistoryGeo(assetIds[0], from, to);
        history = res?.data?.data || [];
      } else {
        console.log("her4")
        const res = await AssetsService.locationHistoryMultiple(assetIds, from, to, selectedSpace, "asset");
        history = res?.data?.data?.history || [];
        console.log("history", history)
        console.log("assetIds, from, to, selectedSpace", assetIds, from, to, selectedSpace)
      }
      console.log("her5")

      if (history.length > 0) {
        const { cleaned, markers } = processNewData(history);

        setData(prevData => {
          const combined = isPoll ? [...cleaned, ...prevData] : cleaned;
          const uniqueMap = new Map();
          combined.forEach(item => uniqueMap.set(item.id, item));
          return Array.from(uniqueMap.values()).sort((a, b) => new Date(b.time) - new Date(a.time));
        });

        setTags(prevTags => {
          const combined = isPoll ? [...markers, ...prevTags] : markers;
          const uniqueMap = new Map();
          combined.forEach(item => uniqueMap.set(item.parentId, item));
          return Array.from(uniqueMap.values()).sort((a, b) => new Date(a.serialNumber) - new Date(b.serialNumber));
        });

        setShowMyFloorplan(true);
        setShowMyFloorplan2(true);
      } else if (!isPoll) {
        setData([]);
        setTags([]);
        setLoadingText('No Data');
        // setShowMyFloorplan(false);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      if (!isPoll) setLoadingText("Error loading data");
    }
  }, [assetIds, startDate, endDate, selectedSpace, isPoll, processNewData]);



  // This effect runs every time the Parent changes the dates or the Poll toggle

  //   const fetchData = useCallback(async () => {
  //     if (!selectedSpace || !startDate || !endDate) return;

  //     // 2. STOP THE DOUBLE RENDER: Fingerprint check
  //     const fingerprint = `${selectedSpace}-${startDate}-${endDate}-${isPoll}-${assetIds.join(',')}`;
  //     if (syncLock.current === fingerprint) return;
  //     syncLock.current = fingerprint;

  //     let from;
  //     const currentData = dataRef.current;

  //     // Polling logic: Only change 'from' if we are actually polling
  //     if (isPoll && currentData.length > 0) {
  //         const latestEntry = currentData[0].time; 
  //         from = moment(latestEntry).format();
  //     } else {
  //         from = moment(startDate).format();
  //         setLoadingText('Loading...');
  //     }

  //     const to = moment(endDate).format();

  //     try {
  //         let history = [];
  //         const isGeoMap = selectedSpace === "6a21bf9e-fc6b-4bec-9f5c-8f8297772091";

  //         if (isGeoMap) {
  //             const res = await AssetsService.locationHistoryGeo(assetIds[0], from, to);
  //             history = res?.data?.data || [];
  //         } else {
  //             const res = await AssetsService.locationHistoryMultiple(assetIds, from, to, selectedSpace, "asset");
  //             history = res?.data?.data?.history || [];
  //         }

  //         if (history.length > 0) {
  //             // This is your original processing logic that worked
  //             const { cleaned, markers } = processNewData(history);

  //             if (isPoll) {
  //                 // APPEND: Combine new with old, but don't force a re-sort that breaks the map
  //                 setData(prev => [...cleaned, ...prev]);
  //                 setTags(prev => [...markers, ...prev]);
  //             } else {
  //                 // REFRESH: This is exactly what your working version did
  //                 setData(cleaned);
  //                 setTags(markers);
  //             }

  //             setShowMyFloorplan(true);
  //             setShowMyFloorplan2(true);
  //         } else if (!isPoll) {
  //             setData([]);
  //             setTags([]);
  //             setLoadingText('No Data');
  //             setShowMyFloorplan(false);
  //         }
  //     } catch (err) {
  //         console.error("Fetch error:", err);
  //         if (!isPoll) setLoadingText("Error loading data");
  //     }
  // }, [assetIds, startDate, endDate, selectedSpace, isPoll, processNewData]);
  useEffect(() => {
    // 1. Set a timer to run fetchData after a short delay (e.g., 250ms)
    const handler = setTimeout(() => {
      fetchData();
    }, 250);

    // 2. CLEANUP: If the props change again before 250ms is up,
    // this clears the old timer and starts a new one.
    // This effectively "waits until props settle."
    return () => {
      clearTimeout(handler);
    };
  }, [fetchData]); // This triggers whenever fetchData changes (which is when props change)

  const handleSelectionChanged = useCallback(({ selectedRowKeys, selectedRowsData }) => {
    setSelectedRowKeys(selectedRowKeys);
    if (selectedRowsData.length > 0) setSelectedRow(selectedRowsData[0]);
  }, []);

  const handleCellHover = useCallback((e) => {
    if (e.eventType === 'mouseover' && e.data?.space?.localCoordinates) {
      setHoveredCoordinates(e.data.space.localCoordinates);
    } else {
      setHoveredCoordinates(null);
    }
  }, []);

  const renderFloorplan = () => {
    console.log("tags", tags)
    if (!selectedSpace) return null;
    if (selectedSpace === "6a21bf9e-fc6b-4bec-9f5c-8f8297772091") {
      return <FloorplanGeo2 data={data} selectedRow={selectedRow} />;
    }
    if (tags.length === 0) {
      return null;
    } else {
      console.log("tags2", tags)


      return (
        // <FloorplanPopupMultiple
        //   hoveredCoordinates={hoveredCoordinates}
        //   spaceId={selectedSpace}
        //   myMarkers={tags}
        //   type={true ? 'polyline' : 'polyline2'}
        // />
        <FloorplanPopupMultiple
          hoveredCoordinates={hoveredCoordinates}
          spaceId={selectedSpace}
          coordinates={tags}
        />
      );
    }
  };

  return (
    <div className='assetContainer'>
      <Toast setParentToastConfig={setToastConfig} toastBody={toastConfig} />
      <section className='column_two'>
        <DataGrid
          height={(showMyFloorplan && showMyFloorplan2) ? 'calc(100vh - 303px)' : 'calc(100vh - 329px)'}
          dataSource={data}
          keyExpr="id"
          showBorders={true}
          focusedRowEnabled={true}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={handleSelectionChanged}
          onCellHoverChanged={handleCellHover}
          noDataText={loadingText}
          repaintChangesOnly={true}
        >
          <Selection mode={floorplanGeo ? "single" : "multiple"} showCheckBoxesMode="none" />
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <FilterPanel visible={true} />
          <Paging enabled={false} />
          <Column dataField="time" width={"170px"} caption="Date" dataType="datetime" format="yyyy-MM-dd HH:mm:ss" sortOrder="desc" allowFiltering={false} />
          <Column dataField="asset" caption="Asset" />
          <Column dataField="space.name" caption="Space" />
          {!floorplanGeo && <Column dataField="motion" caption="Event" width={"30%"} />}
          {!floorplanGeo && <Column dataField="distance" caption="Distance [m]" />}
        </DataGrid>
        <div className={true ? 'showFloorplan-asset' : 'hideFloorplan'}>
          {renderFloorplan()}
        </div>
      </section>
    </div>
  );
}